<script lang="ts">
  import { errorTracker, postWithJwt, serverlessRoutes } from "lib";
  import Svg from "../UI/Svg.svelte";
  import MiniSpinner from "../UI/MiniSpinner.svelte";
  import { onMount } from "svelte";
  import Message from "./Message.svelte";
  import { payload } from "../../stores/payloadStore";
  import { executeJob } from "../../lib/jobQueue";

  export let sessionId;
  export let sendMessage: (payload: string, model?: string) => Promise<void>;
  export let currentSuggestion: string | null = null;

  let isExpanded = false;

  let now = new Date().toISOString();

  let suggestion = "";
  let currentModel = "";
  let isLoading = false;

  const fetchSuggestion = async () => {
    try {
      if(!sessionId) return;
      isLoading = true;
      suggestion = "";
      currentSuggestion = null;

      await executeJob<string>({
        endpoint: `${serverlessRoutes.SESSION}/${sessionId}/suggest`,
        payload: {},
        onSuccess: (result, jobId, job) => {
          console.log("Result:", result);
          console.log("Full job:", job);
          
          suggestion = result || "";
          currentSuggestion = suggestion;
          
          // Try to extract model from job object
          if (job && job.data && job.data.strategyName) {
            currentModel = job.data.strategyName;
          } else {
            currentModel = "---"; // default fallback
          }
          
          console.log("Current model:", currentModel);
          
          isLoading = false;
        },
        onError: (error) => {
          errorTracker.captureError(error as Error | string, "error", {
            context: "ai_suggestion",
            action: "fetch_suggestion"
          });
          isLoading = false;
        },
        errorMessage: "Failed to generate suggestion",
        timeout: 60000, // 60 seconds for AI suggestions
        showSpinner: false, // Don't show the global job spinner for suggestions
      });
    } catch (error) {
      errorTracker.captureError(error as Error | string, "error", {
        context: "ai_suggestion",
        action: "fetch_suggestion_catch"
      });
      isLoading = false;
    }
  };

  const logAction = async (action: string) => {
    try {
      await postWithJwt(`${serverlessRoutes.AI_LOG}`, {
        valueToIncrement: action,
        model: currentModel || "---"
      });
    } catch (e) {
      errorTracker.captureError(e as Error | string, "error", {
        context: "ai_suggestion",
        action: "log_action",
        logAction: action,
        model: currentModel
      });
    }
  };

  onMount(() => {
    fetchSuggestion();
  });
</script>

{#if !isExpanded}
  <div
    class="fixed flex flex-row text-center justify-center top-16 right-0 left-0 h-fit w-11/12 text-xs bg-white dark:bg-zinc-900 rounded-xl m-auto gap-4 p-4 border border-slate-300 dark:border-zinc-600"
  >
    <div class="flex flex-col justify-center grow">
      <h6 class="text-md font-medium mb-4">Predlog odgovora</h6>
      {#if isLoading || suggestion === ""}
        <div class="max-w-80 flex items-center justify-center">
          <MiniSpinner />
        </div>
      {:else}
        <div class="flex flex-row">
          <div class="h-full w-full">
            <Message
              message={{
                id: 0,
                senderId: 0,
                ref: "",
                sessionId: 0,
                payload: suggestion,
                createdAt: now,
                updatedAt: now,
                deletedAt: null,
              }}
              isMine={true}
              touchstart={() => {}}
              touchend={() => {}}
            />
          </div>
        </div>
      {/if}
    </div>
    <div class="inline-block min-h-fit w-0.5 self-stretch bg-neutral-100 dark:bg-white/10"></div>
    <div class="flex flex-col shrink">
      <div
        tabindex="0"
        role="button"
        class="px-1 py-3"
        on:click={() => (isExpanded = !isExpanded)}
        on:keypress={() => (isExpanded = !isExpanded)}
      >
        <Svg name="collapse" size={24} />
      </div>
      <div
        class="px-1 py-3"
        role="button"
        tabindex="0"
        on:click={() => {
          fetchSuggestion();
          logAction("regenerateCount");
        }}
        on:keydown={() => {
          fetchSuggestion();
          logAction("regenerateCount");
        }}
      >
        <Svg name="refresh" size={18} customColor="bg-slate-900 dark:bg-zinc-200" />
      </div>
      <div
        class="px-1 py-3"
        role="button"
        tabindex="0"
        on:click={() => {
          $payload = suggestion;
          logAction("editCount");
        }}
        on:keydown={() => {
          $payload = suggestion;
          logAction("editCount");
        }}
      >
        <Svg name="edit" size={24} customColor="bg-slate-900 dark:bg-zinc-200" />
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="px-1 py-3"
        role="button"
        tabindex="0"
        on:click={() => {
          //$payload = suggestion;
          sendMessage(suggestion, currentModel);
          //$payload = "";
          logAction("useCount");
        }}
      >
        <Svg name="right-arrow-button" size={26} customColor="bg-primary-500 dark:bg-primary-500" />
      </div>
    </div>
  </div>
{:else}
  <div
    class="fixed flex items-center justify-center top-16 right-4 h-10 w-10 bg-white dark:bg-zinc-900 rounded-xl border border-slate-300 dark:border-zinc-600"
    tabindex="0"
    role="button"
    on:click={() => (isExpanded = !isExpanded)}
    on:keydown={() => (isExpanded = !isExpanded)}
  >
    <Svg name="ai-magic" size={24} />
  </div>
{/if}
